import StandardItem from './StandardItem';
import type { BranchParkingConfig } from '@/services/dto/parking';
import { formatAmount } from '@/utils/parking';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface FeeStandardContentProps {
    feeStdList?: BranchParkingConfig['feeStdList'];
}

export default function FeeStandardContent({ feeStdList }: FeeStandardContentProps) {
    const { t } = useTranslation();
    if (!feeStdList || feeStdList.length === 0) {
        return null;
    }

    return (
        <div className={clsx("space-y-[calc(8*var(--vh-unit))] overflow-auto max-h-[calc(34*4*var(--vh-unit))]", feeStdList.length > 4 ? 'scrollbar-custom-gray-99938f scrollbar-w-4 overflow-y-auto' : 'overflow-y-hidden')}>
            {feeStdList.map((fee) => (
                <StandardItem
                    key={fee.pafeeInfoSeqno}
                    label={fee.prkTm}
                    value={formatAmount(fee.prkAmt)}
                    valueSuffix={t('parking.unit.won')}
                />
            ))}
        </div>
    );
}
